/**
 * External Dependencies
 */
import React, { useState } from "react";
import classNames from "classnames";

/**
 * Internal Dependencies
 */
import Button from "components/button";
import FormTextInput from "components/forms/form-text-input";
import FormPasswordInput from "components/forms/form-password-input";
import FormInputFloatingLabel from "components/forms/form-input-floating-label";
import Card from "components/card";
import vd from "lib/vd";
import Preloader from "components/preloader";
import logo from "assets/images/logo_color.png";
import { Box } from "@towersystems/towersystems-design-system";
import queryString from "querystring";
import { VDCOM } from "lib/vd";
/**
 * Style dependencies
 */
import "./styles.scss";

const SignInForm = () => {
  const [error, setError] = useState(null);
  const [values, setValues] = useState({ usernameOrEmail: "", password: "" });
  const [submitting, setSubmitting] = useState(false);

  React.useEffect(() => {
    const query = queryString.parse(window.location.search.replace("?", ""));
    if (query.t) {
      setSubmitting(true);
      new VDCOM(query.t)
        .authentication()
        .me()
        .then((c) => {
          if (c.token) {
            localStorage.setItem("currentUserCubeJSToken", c.cubeJsToken);
            localStorage.setItem("currentUser", JSON.stringify(c.user));
            localStorage.setItem("currentUserToken", c.token);
            window.location = "/";
          }
        })
        .catch((e) => {
          setSubmitting(false);
        });
    }
  }, []);

  const onSubmitForm = (e) => {
    e.preventDefault();
    loginUser();
  };

  const loginUser = async (e) => {
    const { usernameOrEmail, password } = values;
    setError(null);
    setSubmitting(true);

    return vd
      .authentication()
      .login(usernameOrEmail, password)
      .then(({ token, cubeJsToken, user }) => {
        if (!token) {
          throw new Error("Invalid login");
        }
        localStorage.setItem("currentUserToken", token);
        localStorage.setItem("currentUserCubeJSToken", cubeJsToken);
        localStorage.setItem("currentUser", JSON.stringify(user));
        window.location = "/";
      })
      .catch((error) => {
        setError(error);
        setSubmitting(false);
      });
  };

  const onChangeField = (e) => {
    const { name, value } = e.target;
    setError(null);
    setValues({ ...values, [name]: value });
  };

  const signinStyles = classNames(["signin__form"], {
    "login-form--has-error": !!error,
  });

  return (
    <>
      <Box className="login-form__logo-container">
        <img src={logo} alt="Logo" style={{ height: 60 }} />
      </Box>
      <Card className="login-form">
        <h3 className="login-form__heading">Tower Advantage&trade; Login</h3>
        <form className={signinStyles} onSubmit={onSubmitForm}>
          <FormInputFloatingLabel
            label="Username"
            value={values.usernameOrEmail}
            FormInput={FormTextInput}
            name="usernameOrEmail"
            onChange={onChangeField}
          />
          <FormInputFloatingLabel
            visible={values.visible}
            onChange={onChangeField}
            label="Password"
            name="password"
            value={values.password}
            FormInput={FormPasswordInput}
          />
          {error && (
            <p className="help-text">
              Sorry, username or password don't match.
              <br />
              <a href="//towersystems.com.au/login.html?view=reset">
                Forgot your password?
              </a>
            </p>
          )}
          <Button className="login-form__submit-btn" primary type="submit">
            Log in
          </Button>
          <div className="signin-form__links">
            <a
              className="signin-form__forgot-password"
              href="//towersystems.com.au/login.html?view=reset"
              data-tip="Forgot Password"
              data-for="forgotPassword"
            >
              Forgot your password?
            </a>
          </div>
        </form>
        {submitting && <Preloader />}
      </Card>
    </>
  );
};

export default SignInForm;
